
import angular from 'angular';

const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['$rootScope', '$uibModalInstance', 'object', 'DatalayerUtilsService', 'CommonsModalService', '$filter'],
    required: []
};

export class AncillariesGoToHomeModalController implements ng.IController {
    public model:any;
    public goToHome: any;
    public title: any;
    public stayInFlow: any;
    public description: any;

    constructor (
        private $rootScope:CommonsRootScope,
        private $uibModalInstance:ng.ui.bootstrap.IModalInstanceService,
        private object:object,
        private DatalayerUtilsService:any,
        private CommonsModalService: CommonsModalService,
        private $filter: angular.IFilterService) {
        this.model = this.object;
    }

    ////////////////
    $onInit () {
        this.activate();
        this.getTexts();
    }

    activate = ():void => {
        const idModal:object = this.model && this.model.idModal ? this.model.idModal : this.model;
        this.DatalayerUtilsService.sendDatalayerModalEvent(idModal);
        this.$uibModalInstance.result.then(this.DatalayerUtilsService.removeDatalayerModalAttrs, this.DatalayerUtilsService.removeDatalayerModalAttrs);
    };

    getTexts = (): void => {
        switch (this.model) {
                case 'MMB':
                    this.title = this.$filter('translate')('MODAL_MMB_BACK_HOME_TITLE');
                    this.description = this.$filter('translate')('MODAL_MMB_BACK_HOME_BODY');
                    this.goToHome = this.$filter('translate')('MODAL_MMB_BACK_HOME_BUTTON');
                    this.stayInFlow = this.$filter('translate')('MODAL_MMB_BACK_HOME_LINK');
                    break;
                case 'CKI':
                    this.title = this.$filter('translate')('FLY_NOW_CONFIRMATION_BACK_MODAL_TITLE');
                    this.description = this.$filter('translate')('HEADER_CONFIRMATION_BACK_MODAL_DESCRIPTION');
                    this.goToHome = this.$filter('translate')('FLY_NOW_CONFIRMATION_BACK_MODAL_ACCEPT');
                    this.stayInFlow = this.$filter('translate')('FLY_NOW_CONFIRMATION_BACK_MODAL_LINK');
                    break;
                case 'BKI':
                case 'BBKI':
                    this.title = this.$filter('translate')('MODAL_BACK_HOME_TITLE');
                    this.description = this.$filter('translate')('MODAL_BACK_HOME_BODY');
                    this.goToHome = this.$filter('translate')('MODAL_BACK_HOME_BUTTON');
                    this.stayInFlow = this.$filter('translate')('MODAL_BACK_HOME_LINK');
                    break;
        }
    };

    /**
     * Closes the modal dismissing its instance
     */
    close = ():void => {
        this.$uibModalInstance.dismiss();
    };

    /**
     * Closes the modal calling close method of its instance
     */
    accept = (type:object) => {
        this.$uibModalInstance.close(type);
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'modal ib-modals ib-modals--max-prio ib-modals--md', true, null);
    };

    acceptBuyOnhold = ():void => {
        this.close();
        this.$rootScope.$broadcast('closeNewSeatsMap');
        this.$rootScope.$broadcast('acceptBuyOnhold', true);
    };
}

try {
    AncillariesGoToHomeModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(AncillariesGoToHomeModalController.name, AncillariesGoToHomeModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    AncillariesGoToHomeModalController.$inject = controllerInfo.inject;
    mod.controller(AncillariesGoToHomeModalController.name, AncillariesGoToHomeModalController);
}
